
import en from './en';
import cn from './cn';
import tw from './tw';
import ja from './ja';
import ko from './ko';
export default {
    en: en,
    cn: cn,
    tw: tw,
    ja: ja,
    ko: ko
}


// WEBPACK FOOTER //
// ./src/i18n/langs/index.js